document.addEventListener('DOMContentLoaded', function () {
    const triggers = document.querySelectorAll('[data-cookie-settings]');

    triggers.forEach((trigger) => {
        trigger.addEventListener('click', function (e) {
            e.preventDefault();

            // Complianz
            if (typeof window.complianz === 'object') {
                document.querySelectorAll('.cmplz-manage-consent').forEach((obj) => {
                    obj.click();
                });
            }
            // CookieYes
            else if (typeof window.cookieyes === 'object') {
                window.cookieyes.show();
            }
        });
    });
});
